import { render, staticRenderFns } from "./Lifestyle1.vue?vue&type=template&id=595a2403"
import script from "./Lifestyle1.vue?vue&type=script&lang=js"
export * from "./Lifestyle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports